var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('b-spinner',{staticStyle:{"width":"80px","height":"80px"},attrs:{"variant":"primary"}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }